import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import BranchVersionModal from './BranchVersionModal';

const CreateBranchVersion = ({ isOpen, setIsOpen, refetch }) => {
  return (
    <div>
      <Button
        className="centered"
        size="middle"
        onClick={() => setIsOpen(true)}
      >
        <PlusCircleOutlined />
        Create
      </Button>
      {/* <BranchVersionModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refetch={refetch}
      /> */}
    </div>
  );
};

export default CreateBranchVersion;
